import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { CardController } from 'src/app/shared/card.controller';
import { DataLocalService } from 'src/core/services/data-local.service'
import { ContractPriceView } from './contract-price.view';

interface ContractPriceControllerProps extends ComponentViewProps<PriceElement[]> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contract: ContractItem;
	type: 'cost' | 'price';
	currency: CurrencySummary;
	currencies: CurrencySummary[];
	selectedMarket?: number;
}

@observer
export class ContractPriceController extends React.Component<ContractPriceControllerProps, any> {
	@observable
	dataSet: DataLocalService<PriceElement>;

	constructor(props) {
		super(props);
		this.dataSet = this.props.model != null ? new DataLocalService(this.props.model) : null;
	}

	componentWillReceiveProps(nextProps: Readonly<ContractPriceControllerProps>, nextContext: any) {
		this.dataSet = nextProps.model != null ? new DataLocalService(nextProps.model) : null;
	}

	render() {
		let titlestr = (this.props.type == 'cost') ? 'Cost' : 'Price';
		return (
			<CardController icon='pound' title={titlestr} mode={this.props.mode} className='card-borderless'>
				<ContractPriceView
					contract={this.props.contract}
					mode={this.props.mode}
					model={this.dataSet}
					setBusy={this.props.setBusy}
					type={this.props.type}
					currency={this.props.currency}
					currencies={this.props.currencies}
					selectedMarket={this.props.selectedMarket}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/parts/contract-price.controller.tsx